import React from 'react';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MarqueeStrip from './components/MarqueeStrip';

// Sections (in exact Figma order)
import HeroSection from './sections/HeroSection';
import FeaturesStrip from './sections/FeaturesStrip';
import GoldenHistory from './sections/GoldenHistory';
import ExclusiveDesigns from './sections/ExclusiveDesigns';
import ContactSection from './sections/ContactSection';
import CinematicBanner from './sections/CinematicBanner';
import NewCollections from './sections/NewCollections';
import GoldAdvanceBooking from './sections/GoldAdvanceBooking';
import FAQSection from './sections/FAQSection';

export default function App() {
  return (
    <div className="app">
      {/* Fixed Navbar */}
      <Navbar />

      {/* 1. Hero - Dark brown bg, woman with gold jewellery, white headline */}
      <HeroSection />

      {/* 2. Gold marquee scrolling strip */}
      <MarqueeStrip variant="gold" />

      {/* 3. Features Strip - crimson bg, 4 feature cards */}
      <FeaturesStrip />

      {/* 4. Golden History - left image collage, right white text */}
      <GoldenHistory />

      {/* 5. Exclusive Designs - crimson bg, 4-card carousel */}
      <ExclusiveDesigns />

      {/* 6. Contact Us / Visit - left form, right bride image */}
      <ContactSection />

      {/* 7. Cinematic Banner - full-bleed dark with play button */}
      <CinematicBanner />

      {/* 8. All New Collections - crimson bg, 2-image grid */}
      <NewCollections />

      {/* 9. Gold Advance Booking - cream bg, 30% onwards, gold ornament */}
      <GoldAdvanceBooking />

      {/* 10. FAQ - white bg, accordion */}
      <FAQSection />

      {/* 11. Footer - dark bg, 4-column, newsletter */}
      <Footer />
    </div>
  );
}
